import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const Service = ({image , text , title}) => {
  const {t} =  useTranslation()
  return (
    <div class="bg-transparent service hover:scale-105 hover:-translate-y-4 hover:shadow-2xl hover:shadow-white shadow-inner-white rounded overflow-hidden border-x-8 border-y-2 border border-[#0000ff]">
            <img src={image} alt="Blog Post 1" class="w-full border-b-2 border-[#0000ff] h-52 object-cover" />
            <div className="p-6">
              <h3 className="text-lg font-bold dark:text-[#0000ff] text-blue-500 mb-3 font-serif">{title}</h3>
              <p className="text-white text-sm font-serif">{text}</p>
<p className="text-blue-500 text-[13px] dark:text-[#0000ff] font-semibold mt-4">
  {new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })}
</p>
              <Link  className="mt-4 font-serif inline-block px-4 py-2 rounded tracking-wider dark:bg-[#0000ff] bg-blue-500 hover:bg-white-600 text-white text-[13px]">{t("SButton")}</Link>
            </div>
          </div>
  )
}

export default Service
